/*eslint-disable*/
import React, { useState } from 'react';
import BoundariesSection from 'mapcontrols/sections/BoundariesSection/BoundariesSection';
import DemographicsSection from 'mapcontrols/sections/DemographicsSection/DemographicsSection';
import ReferenceLayersSection from 'mapcontrols/sections/ReferenceLayersSection/ReferenceLayersSection';
import RetailersSection from 'mapcontrols/sections/RetailersSection/RetailersSection';
import { MASS_ACCOUNT_MAP_SECTIONS } from 'mapcontrols/constants';

const DefaultLayerPanel = ({
  onToggle,
  isExpanded = true,
  mapLegendImages = {},
  calculableBoundaryLayers = [],
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeLayerIds = [],
  onLayerToggle = () => {},
  calcPolygonSelections = [],
  calcPolygonLabelSelections = [],
  onCalculablePolygonChange = () => {},
  onCalculablePolygonLabelChange = () => {},
  demographicSelection = null,
  onDemographicChange = () => {},
}) => {
  const togglePanel = () => {
    if (onToggle) onToggle(!isExpanded);
  };
  const [activeSections, setActiveSections] = useState(MASS_ACCOUNT_MAP_SECTIONS);

  const onSectionToggle = (id) => {
    setActiveSections((state) => ({ ...state, [id]: !state[id] }));
  };

  return (
    <>
      <div
        className="leaflet-biglayerpanel-header"
        tabIndex="0"
        aria-label="Open or close this panel"
        id="map-biglayerpanel-header"
        onClick={togglePanel}
      >
        <button
          aria-expanded={isExpanded}
          className="leaflet-biglayerpanel-togglebutton"
          aria-controls="map-biglayerpanel-panel"
          id="map-biglayerpanel-togglebutton"
          tabIndex="-1"
          aria-hidden="true"
        >
          &times;
        </button>
        Map Features
      </div>

      <div
        className="leaflet-biglayerpanel-panel"
        id="map-biglayerpanel-panel"
        aria-labelledby="map-biglayerpanel-togglebutton"
        style={{ display: isExpanded ? 'block' : 'none' }}
      >
        <div className="leaflet-biglayerpanel-accordion">
          <RetailersSection
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeLayerIds={activeLayerIds}
            onLayerToggle={onLayerToggle}
          />
          <BoundariesSection
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            onCalculablePolygonChange={onCalculablePolygonChange}
            onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
            calcPolygonSelections={calcPolygonSelections}
            calcPolygonLabelSelections={calcPolygonLabelSelections}
            calculableBoundaryLayers={calculableBoundaryLayers}
          />
          <ReferenceLayersSection
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeLayerIds={activeLayerIds}
            onLayerToggle={onLayerToggle}
            mapLegendImages={mapLegendImages}
          />
          <DemographicsSection
            calculableBoundaryLayers={calculableBoundaryLayers}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            demographicSelection={demographicSelection}
            onDemographicChange={onDemographicChange}
          />
        </div>
      </div>
    </>
  );
};

export default DefaultLayerPanel;
